import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  emsOfficesList: [],
  isAddEmsOfficeModalOpen: false,
  pageCount: 0,
  page: 1,
  totalItems: 0,
  itemsPerPage: 10,
  searchFilters: {
    search: "",
    sortBy: "id",
    sortColumn: "ASC",
  },
  recordToEdit: null,
  selectedEmsOffices: [],  
};

const useEmsOfficeStore = create(
  devtools((set) => ({
    ...initialState,

    setEmsOfficesList: (emsOfficesList) => set({ emsOfficesList }),
    setIsAddEmsOfficeModalOpen: (isAddEmsOfficeModalOpen) => set({ isAddEmsOfficeModalOpen }),
    setPageCount: (pageCount) => set({ pageCount }),
    setPage: (page) => set({ page }),
    setSearchFilters: (searchFilters) => set({ searchFilters }),
    setRecordToEdit: (recordToEdit) => set({ recordToEdit }),
    setSelectedEmsOffices: (selectedEmsOffices) => set({ selectedEmsOffices }),
    setTotalItems: (totalItems) => set({ totalItems }),
    setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),

    reset: () => set(initialState),
  })),
);

export default useEmsOfficeStore;
